/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_GeburtstagInputs */

const de__field_geburtstag = /** @type {(inputs: _Field_GeburtstagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtstag`)
};

/**

* @param {_Field_GeburtstagInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_geburtstag = /** @type {((inputs?: _Field_GeburtstagInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_GeburtstagInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_geburtstag(inputs)
});